import { h } from 'preact';
import * as BaseComp from 'components/shared/header/header.js';
import { condClass, accessNested } from 'utils/utils';
import s from 'components/shared/header/header.sss';

export default class Header extends BaseComp.default {

	renderToggleButton() {
		const sideNavOpen = this.props.headerData.sideNavOpen;
		const { activePage } = this.props;
		const homeEntStandardLayout = activePage.id === 'homeEnt' && !activePage.data.buttonLayout;

		const openData = accessNested(this.props, 'appData.header.toggleButtonAccessibility.open');
		const closeData = accessNested(this.props, 'appData.header.toggleButtonAccessibility.close');

		let alt = sideNavOpen ? closeData.alt : openData.alt;
		let title  = sideNavOpen ? closeData.title : openData.title;
		let ariaLabel = sideNavOpen ? closeData.ariaLabel : openData.ariaLabel;

		return (
			<div
				class={s.toggleBtn + condClass(sideNavOpen, s.open) + condClass(!sideNavOpen, s.closed) + condClass(homeEntStandardLayout, s.standard)}
				role='button'
				onClick={this.toggleMenu}
				alt={alt && alt}
				title={title && title}
				ariaLabel={ariaLabel && ariaLabel}
				tabIndex='0'
				onKeyDown={this.handleToggleBtnEnter}
			>
				<div class={s.toggleBurger}>
					<div class={s.toggleBurgerLine} />
					<div class={s.toggleBurgerLine} />
					<div class={s.toggleBurgerLine} />
				</div>
			</div>
		);
	}
}
